export function f2fDialogSuccessCallbacks(closeDialog: () => void) {
  return {
    onSuccess: closeDialog,
  };
}

export type F2FScheduleMutationPayload = {
  success?: boolean;
  partial_success?: boolean;
  mutation_kind?: string;
  stage?: string;
  schedule_persisted?: boolean;
  idempotent?: boolean;
  notification_retry?: boolean;
  notification_status?: string;
  notification_error?: string | null;
  notification_status_persisted?: boolean;
  notification_outcome_recorded?: boolean;
  downstream_finalized?: boolean;
  delivery_summary?: { complete?: boolean } | null;
  [key: string]: unknown;
};

export type F2FScheduleUiOutcome =
  | 'notification_delivery_failed'
  | 'notification_status_reconciliation_incomplete'
  | 'downstream_reconciliation_incomplete'
  | 'persisted_incomplete'
  | 'already_saved'
  | 'success';

export function resolveF2FScheduleUiOutcome(
  payload: F2FScheduleMutationPayload,
): F2FScheduleUiOutcome {
  const deliveryFailed = payload.notification_status === 'failed' ||
    payload.notification_status === 'partial' ||
    payload.delivery_summary?.complete === false;
  if (deliveryFailed) return 'notification_delivery_failed';

  if (
    payload.notification_status_persisted === false ||
    payload.notification_outcome_recorded === false
  ) {
    return 'notification_status_reconciliation_incomplete';
  }

  if (payload.downstream_finalized === false) {
    return 'downstream_reconciliation_incomplete';
  }

  const fullyReconciled = payload.schedule_persisted === true &&
    payload.notification_status === 'sent' &&
    payload.notification_status_persisted === true &&
    payload.downstream_finalized === true;

  if (!fullyReconciled) return 'persisted_incomplete';
  return payload.idempotent ? 'already_saved' : 'success';
}

export function persistedF2FScheduleResult(
  payload: F2FScheduleMutationPayload | null | undefined,
): F2FScheduleMutationPayload | null {
  return payload?.schedule_persisted === true ? payload : null;
}
